import React, { useEffect } from "react";
import { object, func, string } from "prop-types";
import { connect } from "react-redux";
import { LoadMoreStoriesBase } from "@quintype/components";
import get from "lodash/get";

import Headline from "../../atoms/headline";
import MoreCollectionStories from "../../rows/more-collection-stories";
import { QuintTopResponsiveContainer } from "../../rows/ad-free";

import { setLoading } from "../../helper/actions";
import { addGTMPageVariables } from "../../utils/utils";

import "./tag.m.css";

const NO_OF_ITEMS_LOAD = 12;
const storyFields =
  "headline,subheadline,author-name,author-id,authors,last-published-at,hero-image-metadata,hero-image-s3-key,slug,id,story-template,tags,url,metadata";

const TagPageBase = ({ data, setLoading, publisherName }) => {
  const { tag } = data;

  useEffect(() => {
    addGTMPageVariables(null, "WEB", null, "TOPIC");
  }, []);

  return (
    <div styleName="wrapper" className="container">
      <QuintTopResponsiveContainer mobile="topAd" desktop="topAd" />

      <Headline text={tag.name || "Tag"} headerType={9} />

      {data.stories.length ? (
        <LoadMoreStoriesBase
          template={(e) => MoreCollectionStories(e, NO_OF_ITEMS_LOAD, setLoading, publisherName)}
          fields={storyFields}
          params={{ "tag-slugs": tag.slug }}
          data={data}
          numStoriesToLoad={NO_OF_ITEMS_LOAD}
        />
      ) : (
        <div styleName="no-stories">No stories found !!</div>
      )}
    </div>
  );
};

TagPageBase.propTypes = {
  data: object,
  setLoading: func,
  publisherName: string,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

const mapDispatchToProps = (dispatch) => ({
  setLoading: (isLoading) => dispatch(setLoading(isLoading)),
});

const TagPage = connect(mapStateToProps, mapDispatchToProps)(TagPageBase);

export { TagPage };
